import { apiClient } from './client';

export interface BlockedEntity {
    key: string;
    reason: string;
    until: number;  // Epoch timestamp when block expires
    count: number;  // Number of violations that led to block
}

export interface RateLimitStats {
    backend: string;
    config: {
        limits: { anonymous: number; authenticated: number; premium: number };
        windowMs: number;
        burstThreshold: number;
    };
}

export const rateLimitApi = {
    getBlockedUsers: async () => {
        try {
            const response = await apiClient.get<{ success: boolean; blocked: BlockedEntity[] }>('/admin/rate-limit/blocked');
            return response.data.blocked;
        } catch (error: any) {
            // Handle 404 transparently (if endpoint not yet deployed/ready)
            if (error.response?.status === 404) return [];
            throw error;
        }
    },

    unblockUser: async (key: string, resetTrust: boolean = true) => {
        const response = await apiClient.post<{ success: boolean; message: string; wasBlocked: boolean }>('/admin/rate-limit/unblock', {
            key,
            resetTrust
        });
        return response.data;
    },

    getStats: async () => {
        const response = await apiClient.get<{ success: boolean; stats: RateLimitStats }>('/admin/rate-limit/stats');
        return response.data.stats;
    }
};
